import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Vi bruger cookies',
    description:
      'Vi bruger cookies og lignende teknologier til at levere denne oplevelse. Strengt nødvendige cookies er altid aktive.',
    allow_label: 'Acceptér alle cookies',
    reject_label: 'Kun strengt nødvendige',
    settings_label: 'Cookieindstillinger',
    policy_link_label: 'Privatlivs- og cookiepolitik',
    categories_label: 'Kategorier',
    always_on_label: 'Altid aktiv',
    required_label: 'Påkrævet',
    save_preferences_label: 'Gem indstillinger',
    close_label: 'Luk',
    allow_all_optional_categories_label: 'Tillad alle valgfrie kategorier',
    save_error: 'Din privatlivsindstilling kunne ikke gemmes. Prøv igen.'
  },
  categories: {
    strictly_necessary: {
      name: 'Strengt nødvendige',
      purpose: 'Påkrævet for at levere denne oplevelse og kan ikke deaktiveres.'
    },
    analytics: {
      name: 'Analyse',
      purpose: 'Måler, hvordan besøgende bruger denne oplevelse, så ydeevnen kan forbedres.'
    },
    marketing: { name: 'Markedsføring', purpose: 'Understøtter annoncering og markedsføring valgt af arrangøren.' }
  }
};

export default locale;
